const REDIRECT_STORAGE_KEY = "kc_post_login_redirect";
const INTERNAL_ROLE_KEY = "kc_internal_role";
const ACCESS_TOKEN_KEY = "auth_token";
const REFRESH_TOKEN_KEY = "refreshToken";
const ID_TOKEN_KEY = "id_token";

const isBrowser = () => typeof window !== "undefined";

const normalizeRedirect = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  if (value.startsWith("http://") || value.startsWith("https://")) {
    return null;
  }

  if (!value.startsWith("/")) {
    return `/${value}`;
  }

  return value;
};

export const getKeycloakRedirectUri = () => {
  const envRedirect = process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;

  if (envRedirect) {
    return envRedirect;
  }

  if (!isBrowser()) {
    return "";
  }

  return `${window.location.origin}/auth/callback`;
};

export const getPostLogoutRedirectUri = (fallbackPath = "/") => {
  const envRedirect = process.env.REACT_APP_KEYCLOAK_POST_LOGOUT_REDIRECT_URI;

  if (envRedirect) {
    return envRedirect;
  }

  if (!isBrowser()) {
    return "";
  }

  return `${window.location.origin}${fallbackPath}`;
};

export const setPostLoginRedirect = (path) => {
  if (!isBrowser()) {
    return;
  }

  const normalized = normalizeRedirect(path);

  if (normalized) {
    window.sessionStorage.setItem(REDIRECT_STORAGE_KEY, normalized);
  }
};

export const consumePostLoginRedirect = (fallback = "/dashboard") => {
  if (!isBrowser()) {
    return fallback;
  }

  const stored = window.sessionStorage.getItem(REDIRECT_STORAGE_KEY);
  window.sessionStorage.removeItem(REDIRECT_STORAGE_KEY);

  return normalizeRedirect(stored) || fallback;
};

export const setInternalRole = (role) => {
  if (!isBrowser()) {
    return;
  }
console.log("keycloakAuth", role)
  if (!role) {
    window.sessionStorage.removeItem(INTERNAL_ROLE_KEY);
    return;
  }

  window.sessionStorage.setItem(INTERNAL_ROLE_KEY, role);
};

export const getInternalRole = () => {
  if (!isBrowser()) {
    return null;
  }

  return window.sessionStorage.getItem(INTERNAL_ROLE_KEY);
};

export const consumeInternalRole = () => {
  if (!isBrowser()) {
    return null;
  }

  const stored = window.sessionStorage.getItem(INTERNAL_ROLE_KEY);
  window.sessionStorage.removeItem(INTERNAL_ROLE_KEY);
  return stored;
};

export const clearInternalRole = () => {
  if (!isBrowser()) {
    return;
  }

  window.sessionStorage.removeItem(INTERNAL_ROLE_KEY);
};

export const persistKeycloakTokens = (user) => {
  if (!isBrowser() || !user?.access_token) {
    return;
  }

  window.localStorage.setItem(ACCESS_TOKEN_KEY, user.access_token);

  if (user.refresh_token) {
    window.localStorage.setItem(REFRESH_TOKEN_KEY, user.refresh_token);
  }

  if (user.id_token) {
    window.localStorage.setItem(ID_TOKEN_KEY, user.id_token);
  }
};

export const clearKeycloakTokens = () => {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem("userId");
  clearInternalRole();
};
